import { camelCase } from 'lodash';
import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import { Inbox } from '@rossum/api-client/inboxes';
import { INBOX_QUERY_KEY } from '../../../features/document-upload/hooks/useGetInbox';
import { errorHandler } from '../../../lib/api';
import { convertKeys } from '../../../lib/keyConvertor';
import { invalidateQueryClientCache } from '../../middlewares/queryClientMiddleware';
import { throwError, throwInfo } from '../messages/actions';
import { isActionOf, makeEpic } from '../utils';
import { setValidationMessagesAction } from '../validationMessages/action';
import { updateInboxAction, updateInboxFulfilled } from './actions';

const updateInboxEpic = makeEpic((action$, _, { authPatch$ }) =>
  action$.pipe(
    filter(isActionOf(updateInboxAction)),
    mergeMap(({ payload: { inbox }, meta: { inboxUrl } }) =>
      authPatch$<Inbox>(inboxUrl, inbox).pipe(
        mergeMap(response => {
          return of(
            updateInboxFulfilled(response),
            invalidateQueryClientCache([INBOX_QUERY_KEY]),
            throwInfo('inbox.updated')
          );
        }),
        catchError(xhr =>
          xhr.status === 400
            ? of(
                setValidationMessagesAction(
                  convertKeys(camelCase)(xhr.response),
                  'inbox'
                ),
                throwError('inboxUpdatedError')
              )
            : errorHandler(xhr)
        )
      )
    )
  )
);

export default combineEpics(updateInboxEpic);
